import Mark from 'mark.js';

export default function () {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('highlight');
    if (query) {
        let instance = new Mark(document.querySelector("#content"));
        instance.mark(query);
    }

}